<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>
            <BTabs :active-tab.sync="active_tab" >
              <BTab  :title="$t('RouteInsert')">
                <InsertRoutes/>
              </BTab>

              <BTab :title="$t('cars')">
                <InsertWheicle/>
              </BTab>

              <BTab :title="$t('driverRoute')">
                <DeliveryInserts/>
              </BTab>

              <BTab :title="$t('visitorRoute')">
                <SalesmanInserts/>
              </BTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";
var items = [];
import DeliveryOperations from "./DeliveryOperations";
import InsertRoutes from "./InsertRoutes"
import InsertWheicle from "./InsertWheicle";
import DeliveryInserts from "./DeliveryInserts";
import SalesmanInserts from "./VisitorRoutes.vue";
import BTab from "../../tabs/BTab";
export default {
  name: 'SaleSettingsComponent',
  components: {
    BTab,
    BTabs,
    DeliveryOperations,
    SalesmanInserts,
    InsertRoutes,
    InsertWheicle,
    DeliveryInserts
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      active_tab:parseInt(localStorage.getItem("sale_setting_active_tab",0)),

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    // this.get_lists();

  }, watch: {

    'active_tab': function () {
      localStorage.setItem("sale_setting_active_tab",this.active_tab)
    }
  },
  methods: {

  }
}

</script>
